import { render, staticRenderFns } from "./loadingPage.vue?vue&type=template&id=0896789a&scoped=true&"
import script from "./loadingPage.vue?vue&type=script&lang=js&"
export * from "./loadingPage.vue?vue&type=script&lang=js&"
import style0 from "./loadingPage.vue?vue&type=style&index=0&id=0896789a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0896789a",
  null
  
)

component.options.__file = "loadingPage.vue"
export default component.exports